import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductConfig } from '../@types/context/product-config.types';
import type { ProductCreditCardConfig } from '../@types/context/product-credit-card-config.types';
import type { ProductSecuredLoanConfig } from '../@types/context/product-secured-loan-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactAxoNoConfig } from './presets/contact-axo-no.config';
import { creditCardNoConfig } from './presets/credit-card-no.config';
import { globalNo } from './presets/global-no.config';
import { insuranceMypageNo } from './presets/insurance-mypage.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { organisationAxoNoConfig } from './presets/organisation-axo-no.config';
import { productConfigNo } from './presets/product-config.preset';
import { securedLoanCaseConfig } from './presets/secured-loan-case.config';
import { securedLoanNoConfig } from './presets/secured-loan-no.config';
import { serviceTrustpilotAxoNoConfig } from './presets/service-trustpilot-axo-no.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansNoConfig } from './presets/unsecured-loans-no.config';

export const global: GlobalConfig = {
  brand: 'axofinans.no',
  ...globalNo,
};

export const site: SiteConfig = {
  domain: 'axofinans.no',
  name: 'Axo Finans',
  theme: {
    name: 'axo-finans',
    brand: 'axo-finans',
  },
  path: {
    loansApply: '/soknad/forbrukslan',
    loansPreForm: '/forbrukslan',
    mypage: 'https://mypage.axofinans.no',
    securedLoansApply: '/soknad/lan-med-sikkerhet',
    securedLoansBookCall: '/soknad/lan-med-sikkerhet/bestill-samtale',
    securedLoansPreflight: '/soknad/lan-med-sikkerhet/forhandssjekk',
    securedLoansApplySmart: '/soknad/lan-med-sikkerhet/smart',
    securedLoansMypage: '/mine-tilbud/lan-med-sikkerhet',
    insurance: '/soknad/forsikring',
    oneFormPreflight: '/soknad/forhandssjekk',
    oneFormApply: '/soknad/lan',
    oneFormRecommendations: '/soknad/lan/anbefalinger',
    mypageOverview: '/mine-tilbud',
    mypageLoans: '/mine-tilbud/forbrukslan',
    mypageCreditCards: '/mine-tilbud/kredittkort',
    mypageSecuredLoans: '/mine-tilbud/lan-med-sikkerhet',
    creditCard: '/soknad/kredittkort',
    ...insuranceMypageNo,
  },
  ...organisationAxoNoConfig,
  ...contactAxoNoConfig,
  verification: {
    google: 'dlIHJW6C4l0oOKU_N-rtTc2uhnK5nJSw14b9dw0-CHw',
  },
  services: {
    cms: {
      provider: 'prepr',
    },
    cookieConsentManager: {
      provider: 'cookieyes',
      cookieyes: {
        siteId: { production: '1a8c602e9c8984e17393c7c94ff6b1b6' },
        scriptStrategy: 'lazyOnload',
      },
    },
    // Live TrustScore as review-snippet stars in the page JSON-LD (MVF-132).
    trustpilot: {
      ...serviceTrustpilotAxoNoConfig,
      reviewSnippet: true,
      showInForms: true,
    },
    gtm: 'GTM-T9326N',
    ga: 'G-VM1458YKKN',
    // SPIKE: defer GTM off the critical path (see axolaina.fi). Measure first.
    gtmScriptStrategy: 'lazyOnload',
    launchDarkly: {
      enabled: true,
      anonymousExperimentsEnabled: false,
    },
    statsig: {
      enabled: true,
      autoCapture: false,
      sessionReplay: false,
      proxyEnabled: true,
    },
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansNoConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const productCreditCard: ProductCreditCardConfig = {
  ...creditCardNoConfig,
};

export const myPage: MyPageConfig = {
  options: {
    hasHighCostWarning: false,
    isCreditCardRecommendedVisible: false,
    creditCard: { hasApplyForm: true },
    ...myPageOffersConfig,
  },
};

export const productSecuredLoan: ProductSecuredLoanConfig = {
  ...securedLoanNoConfig,
  ...securedLoanCaseConfig,
};

export const product: ProductConfig = productConfigNo;
